import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Building2 } from "lucide-react";

export function CdcRiepilogoCard({ cdcRiepilogoData, selectedMesi, formatCurrency }) {
  const cdcList = cdcRiepilogoData.originali;
  const mesiKeys = selectedMesi;

  return (
    <Card className="mt-6" data-testid="riepilogo-cdc-card">
      <CardHeader className="pb-3">
        <CardTitle className="text-lg flex items-center gap-2">
          <Building2 className="w-5 h-5" />
          Riepilogo Costi per Centro di Costo
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse text-sm">
            <thead className="sticky top-0 z-10">
              <tr className="border-b bg-slate-50">
                <th className="text-left p-2.5 font-semibold min-w-[220px] sticky left-0 bg-slate-50 z-20">Centro di Costo</th>
                {mesiKeys.map(m => (
                  <th key={m} className="text-right p-2.5 font-semibold min-w-[90px] bg-slate-50">{m}</th>
                ))}
                <th className="text-right p-2.5 font-bold min-w-[110px] bg-slate-100">TOTALE</th>
              </tr>
            </thead>
            <tbody>
              {cdcList.map((cdc, i) => {
                const totale = mesiKeys.reduce((s, m) => s + (cdc.mesi[m] || 0), 0);
                return (
                  <tr key={cdc.id} className={`border-b ${i % 2 === 0 ? "bg-white" : "bg-slate-50/30"}`} data-testid={`cdc-row-${cdc.id}`}>
                    <td className={`p-2.5 sticky left-0 z-10 ${i % 2 === 0 ? "bg-white" : "bg-slate-50/30"}`}>
                      <span className="font-medium">{cdc.nome}</span>
                    </td>
                    {mesiKeys.map(m => (
                      <td key={m} className="p-2.5 text-right font-mono">
                        {cdc.mesi[m] ? formatCurrency(cdc.mesi[m]) : "-"}
                      </td>
                    ))}
                    <td className="p-2.5 text-right font-mono font-semibold">
                      {formatCurrency(totale)}
                    </td>
                  </tr>
                );
              })}
              <tr className="border-t-2 bg-slate-100 font-bold">
                <td className="p-2.5 sticky left-0 bg-slate-100 z-10">TOTALE</td>
                {mesiKeys.map(m => {
                  const tot = cdcList.reduce((s, cdc) => s + (cdc.mesi[m] || 0), 0);
                  return <td key={m} className="p-2.5 text-right font-mono">{formatCurrency(tot)}</td>;
                })}
                <td className="p-2.5 text-right font-mono text-base">
                  {formatCurrency(cdcList.reduce((s, cdc) => s + mesiKeys.reduce((s2, m) => s2 + (cdc.mesi[m] || 0), 0), 0))}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
}
